import { GridColumnBaseConfiguration } from "./grid-column-base-configuration";

export class GridCheckboxColumnConfiguration extends GridColumnBaseConfiguration {
  constructor(
    fieldName: string,
    title: string,
    classname: string,
    sortOrder: string = null,
  ) {
    super("checkbox", fieldName, title, classname, sortOrder);
  }
}
